"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lambdaParameterConfig = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const assertions_1 = require("../assertions");
const helpers_1 = require("../misc/helpers");
const envConfig_1 = require("./envConfig");
const _1 = require(".");
const lambdaExtensionUrl = 'http://localhost:2773';
let lambdaExtensionReadyPromise;
/**
 * Returns a value from the AWS Parameter Store. Can only be used during in AWS Lambda, and
 * requires that the AWS Parameters and Secrets Lambda Extension Layer be included in the Lambda.
 * This extension has built-in caching for requested parameters.
 *
 * @param parameterName the name of the parameter; can be a literal name (string) or can itself
 * be accessed via another parameter by giving a configuration value provider.
 * @example const someValue = resolveConfig(lambdaParameterConfig('some-parameter-name'));
 * @returns the configuration value provider for the value
 */
const lambdaParameterConfig = (parameterName) => async () => {
    const token = await (0, _1.resolveConfigValue)((0, envConfig_1.envConfig)('AWS_SESSION_TOKEN', 'runtime'));
    const name = await (0, _1.resolveConfigValue)(parameterName);
    if (!lambdaExtensionReadyPromise) {
        // This request will return 400 Bad Request,
        // but we only care that it'll block until the extension is ready
        lambdaExtensionReadyPromise = (0, helpers_1.retryWithDelay)(() => (0, node_fetch_1.default)(lambdaExtensionUrl));
    }
    await lambdaExtensionReadyPromise;
    const resp = await (0, helpers_1.retryWithDelay)(() => (0, node_fetch_1.default)(
    // Port 2773 is the default port for the extension
    `${lambdaExtensionUrl}/systemsmanager/parameters/get?name=${name}&withDecryption=true`, { headers: { 'X-Aws-Parameters-Secrets-Token': token } }));
    if (resp.ok) {
        const response = await resp.json();
        const parameter = (0, assertions_1.assertDefined)(response.Parameter, `aws GetParameter response missing Parameter key for ${name}"`);
        return (0, assertions_1.assertDefined)(parameter.Value, `aws GetParameter response missing Parameter.Value key for ${name}"`);
    }
    else {
        throw new Error(`HTTP Error Response ${resp.status} ${resp.statusText} while fetching parameter ${name}`);
    }
};
exports.lambdaParameterConfig = lambdaParameterConfig;
